import { render } from "./SwipeActionsContainer.vue?vue&type=template&id=25389ae2&scoped=true"
import script from "./SwipeActionsContainer.vue?vue&type=script&lang=js"
export * from "./SwipeActionsContainer.vue?vue&type=script&lang=js"

import "./SwipeActionsContainer.vue?vue&type=style&index=0&id=25389ae2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25389ae2"]])

export default __exports__